/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Collaborators_Manageroles_Savesuccess2Inputs */

const en_settings_collaborators_manageroles_savesuccess2 = /** @type {(inputs: Settings_Collaborators_Manageroles_Savesuccess2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Roles updated for ${i?.count} collaborators`)
};

/**
* | output |
* | --- |
* | "Roles updated for {count} collaborators" |
*
* @param {Settings_Collaborators_Manageroles_Savesuccess2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_savesuccess2 = /** @type {((inputs: Settings_Collaborators_Manageroles_Savesuccess2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Savesuccess2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_savesuccess2(inputs)
});
export { settings_collaborators_manageroles_savesuccess2 as "settings_collaborators_manageRoles_saveSuccess" }